/*
 * Copyright (c) 2019 brightlamp
 */

const Anonymous = () => import(/* webpackChunkName: "anonymous" */ '@/views/anonymous');
const ForgotPassword = () => import(/* webpackChunkName: "anonymous" */ '@/views/anonymous/forgot-password');

export default
[
    {
        path: '/anonymous/',
        component: Anonymous,
        meta:
        {
            requiresAnonymous: true
        },
        children:
        [
            {
                path: 'forgot-password',
                name: 'Forgot Password',
                component: ForgotPassword,
                meta:
                {
                    title: 'Forgot Password'
                }
            }
        ]
    }
]